// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setVariables(templateString: string, params: any[]) {
	return templateString.replace(/\$/g, (match, offset, string) => {

		const index = [...string.slice(0, offset)].filter(char => char === '$').length;
		return params[index] || '';
	});
}

